import MyDocument from './MyDocument'
import ShareWithMe from './ShareWithMe'

export const tabs = [
    {
        label: 'share-with-me',
        value: 'share-with-me',
        component: <ShareWithMe />,
    },
    {
        label: 'my-document',
        value: 'my-document',
        component: <MyDocument />,
    },
]
